import { type ButtonHTMLAttributes, type ReactElement, type ReactNode } from 'react';
import { cx } from './library-kit';

export interface SwitchProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange' | 'role' | 'aria-checked' | 'style' | 'className' | 'children' | 'type'> {
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
  /** The visible label (also the accessible name). Without it, give the switch an `aria-label` or `aria-labelledby`. */
  readonly label?: ReactNode;
  readonly className?: string;
}

/**
 * The on/off switch (Design System FX-13): a 46×27 track with a 22px thumb that slides 19px in 200ms, inside the 48px hit
 * box. A `<button role="switch">` — Space and Enter toggle it, `aria-checked` carries the state, `disabled` is honoured. The
 * thumb keeps sliding under `prefers-reduced-motion` (only the FX classes are stilled, like the design).
 */
export function Switch({ checked, onChange, label, className, disabled, ...rest }: SwitchProps): ReactElement {
  return (
    <button type="button" role="switch" aria-checked={checked} className={cx('vello-switch', className)} disabled={disabled} onClick={() => onChange(!checked)} {...rest}>
      <span className="vello-switch__track" aria-hidden="true">
        <span className="vello-switch__thumb" />
      </span>
      {label !== undefined && <span className="vello-switch__label">{label}</span>}
    </button>
  );
}
